import { BaseModel } from 'src/app/_metronic/shared/crud-table';
import { Karyawan } from './pegawai/karyawan.model';

export class DataKlinik {
  constructor(
    public id: number,
    public uuid?: string,
    public nama?: string,
    public alias?: string,
    public logo?: string,
    public telepon1?: string,
    public telepon2?: string,
    public alamat?: string,
    public email?: string,
    public latitude?: string,
    public longitude?: string,
    public lokasi?: string,
    public noRekamMedis?: string,
    public typePrice?: string,
    public bayarPendaftaranAwal?: number,
    public idGroupDataKlinik?: number,
    public asesmenNyeri?: number,
    public filterTarifInstallasi?: number,
    public filterBarangNasabah?: number,
    public sharingPasien?: number,
    public pemotonganStok?: number,
    public noGigiTindakan?: number,
    public cicilan?: number,
    public timeZone?: string,
    public statusBpjs?: number,
    public statusHargaResep?: number,
    public kodePpkBpjs?: string,
    public kunciResepKlinik?: number,
    public statusInputBiayaAwal?: number,
    public statusInputTarifTindakan?: number,
    public statusBayarPendaftaran?: number,
    public statusHapusKunjungan?: number,
    public statusStockHabisResep?: number,
    public statusStockRiwayatResep?: number,
    public statusCekSipResep?: number,
    public statusFornasResep?: number,
    public statusSendAppointmentWhatsapp?: number,
    public statusBannerSubscriptions?: number,
    public settingPrintSep?: number,
    public statusOrderAntrianMedis?: number,
    public notifikasiResepException?: string,
    public statusKapasitasDokterDaftarRajal?: number,
    public statusStickyHeaderMedis?: number,
    public statusInputDiagnosaText?: number,
    public statusTambahCssd?: number,
    public statusNotifikasiBatalAntrian?: number,
    public pendaftaranDisabled?: number,
    public pendaftaranDisabledException?: string,
    public _embedded?: {
      tipeInstitusi: any;
    }
  ) {}
}

export interface DataKlinikV2 extends BaseModel {
  klinikMaker?: KlinikMaker;
  id: number;
  uuid: string;
  kodeDataKlinik: string;
  namaOwner: string;
  nama: string;
  alias: string;
  url: string;
  url2: string;
  lokasi: string;
  logo: string;
  telepon1: string;
  telepon2: string;
  alamat: string;
  email: string;
  instagram: string;
  twitter: string;
  facebook: string;
  linkedin: string;
  website: string;
  latitude: string;
  longitude: string;
  noRekamMedis: string;
  typePrice: string;
  idGroupDataKlinik: number;
  sharingPasien: number;
  rangeVoid: number;
  deskripsi: string;
  timeZone: string;
  typeFarmasi: string;
  strukPos: string;
  strukKasir: string;
  metodeDiskon: number;
  hargaSatuan: number;
  diskonPos: number;
  anamnesis: number;
  pemeriksaanPenunjang: number;
  masalahMedis: number;
  tindakanParameter: number;
  cicilan: number;
  asesmenNyeri: number;
  filterTarifInstalasi: number;
  icd10: number;
  icd10Gigi: number;
  icd9Cm: number;
  tindakanMinmed: number;
  delivery: number;
  noGigiTindakan: number;
  questionTindakan: number;
  pemeriksaanVital: number;
  kodePpkBpjs: string;
  bayarPendaftaranAwal: number;
  pemotonganStok: number;
  idKategoriKlinik: number;
  urlBpjs?: string;
  statusInputTindakan?: number;
  statusInputResep?: number;
  filterBarangNasabah?: number;
  statusBpjs?: number;
  statusHargaResep?: number;
  kunciResepKlinik?: number;
  statusInputBiayaAwal?: number;
  statusInputTarifTindakan?: number;
  statusBayarPendaftaran?: number;
  ttsSpeakingRate?: string;
  statusQtyTindakan?: number;
  statusAppointmentMobile?: number;
  consIdBpjs?: string;
  passwordBpjs?: string;
  userKeyBpjs?: string;
  statusHapusKunjungan?: number;
  regional?: number;
  tipeFaskes?: string;
  kelasFaskes?: string;
  nominalKlaimInacbg?: number;
  nominalKlaimInacbgRajal?: number;
  totalJamKerjaAbsen?: number;
  statusTuslah?: number;
  statusRadiusInputCppt?: number;
  foto1?: string;
  sharingStock?: number;
  statusStockHabisResep?: number;
  statusStockRiwayatResep?: number;
  bannerImage?: string;
  statusHapusRujukan?: number;
  statusCekSipResep?: number;
  statusSendAppointmentWhatsapp?: number;
  statusBannerSubscriptions?: number;
  settingPrintSep?: number;
  statusOrderAntrianMedis?: number;
  statusFornasResep?: number;
  notifikasiResepException?: string;
  statusKapasitasDokterDaftarRajal?: number;
  statusEditHargaTindakanMedis?: number;
  statusStickyHeaderMedis?: number;
  statusInputDiagnosaText?: number;
  statusTambahCssd?: number;
  statusBatalPasienOtomatis?: string;
  statusSelesaiPasienOtomatis?: string;
  statusNotifikasiBatalAntrian?: number;
  pendaftaranDisabled?: number;
  pendaftaranDisabledException?: string;
}

export interface KlinikMaker extends BaseModel {
  fotoIdentitas: string;
  idKaryawan: number;
}
